import { CurrencyInputNetwork, CurrencyInputToken } from '../../CurrencyInputTypes';
import { FC, useCallback, useMemo } from 'react';
import { DecimalFormat } from '@tempusfinance/decimal';
import Typography from '../../../Typography';

import './NetworkSelectorItem.scss';

interface NetworkSelectorItemProps {
  network: CurrencyInputNetwork;
  selectedToken: CurrencyInputToken;
  onClick: (network: CurrencyInputNetwork) => void;
}

const NetworkSelectorItem: FC<NetworkSelectorItemProps> = ({ network, selectedToken, onClick }) => {
  const balanceFormatted = useMemo(() => {
    if (!network.balance) {
      return null;
    }

    return DecimalFormat.format(network.balance, {
      style: 'currency',
      currency: selectedToken.symbol,
      fractionDigits: 4,
      pad: true,
    });
  }, [network.balance, selectedToken.symbol]);

  const showBalance = useMemo(() => {
    return network.balance && network.balance.gt(0);
  }, [network.balance]);

  const handleClick = useCallback(() => {
    onClick(network);
  }, [network, onClick]);

  return (
    <div className="nostra__networkSelectorItem" onClick={handleClick}>
      <div className="nostra__networkSelectorItem__name">
        <img className="nostra__networkSelectorItem__logo" src={network.logoUrl} />
        <Typography variant="table-body-lg" weight="semi-bold">
          {network.displayName}
        </Typography>
      </div>
      {showBalance && <Typography variant="body-md">{balanceFormatted}</Typography>}
    </div>
  );
};
export default NetworkSelectorItem;
